import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="w-full bg-[#0a1410] border-t border-amber-900/30 py-8 md:py-12" data-id="element-118">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-120">
          {/* Brand */}
          <h3 className="text-2xl font-bold text-amber-500 mb-2 md:mb-4" data-id="element-121">
            RECURSOHUB™
          </h3>

          {/* Tagline */}
          <p className="text-lg text-white font-semibold mb-1 md:mb-2" data-id="element-122">
            El sistema de rehabilitación N°1 para kinesiólogo, profe de
            educación física, entrenador personal o instructor de gym en
            Argentina
          </p>

          <p className="text-gray-400 mb-4 md:mb-8" data-id="element-123">
            Porque ejercer no debería costarte todas las tardes del año.
          </p>

          {/* Contact */}
          <div className="text-gray-300 mb-4 md:mb-8 space-y-1" data-id="element-124">
            <p data-id="element-125">📧 atencionrecursohub@gmail.com</p>
            <p data-id="element-126">🌐 www.recursohub.com</p>
          </div>

          {/* Copyright */}
          <div className="text-sm text-gray-500 mb-4 md:mb-6" data-id="element-127">
            <p data-id="element-128">© recursoHUB™ 2026 — Todos los derechos reservados.</p>
            <p data-id="element-129">
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>

          {/* Final Quote */}
          <p className="text-xl font-bold text-amber-500 italic" data-id="element-130">
            "La próxima semana puede ser diferente."
          </p>
        </motion.div>
      </div>
    </footer>;
}